import type { Dialect } from '@/providers/LearnerPreferences';

export const MODE_OPTIONS: readonly Dialect[] = ['hmonglus', 'moob'];

export const MODE_LABELS: Record<Dialect, string> = {
  hmonglus: 'Hmonglus',
  moob: 'Moob',
};

/** Short dialect descriptions shown beside each mode in the switcher. */
export const MODE_DESCRIPTIONS: Record<Dialect, string> = {
  hmonglus: 'White Hmong',
  moob: 'Hmong Leng/Green Hmong',
};
